<template>
    <ot-section v-bind="$attrs" :theme="$otTheme" section>
        <ot-notice>
            `indicator-position` 属性定义了指示器的位置。默认情况下，它会显示在走马灯内部，设置为 `outside` 则会显示在外部；设置为 `none` 则不会显示指示器。
        </ot-notice>
        <ot-row-group :theme="$otTheme" :fixable="false" :flex="false" :code="code">
            <ot-carousel indicator-position="outside">
                <ot-carousel-item v-for="item in 'abcd'.split('')" :key="item">
                    <h3>{{ item }}</h3>
                </ot-carousel-item>
            </ot-carousel>
        </ot-row-group>
    </ot-section>
</template>

<script>
export default {
    data() {
        return {
            code: decodeURIComponent(`%3Ctemplate%3E%0A%20%20%20%20%3Cot-section%20section%3E%0A%20%20%20%20%20%20%20%20%3Cot-notice%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%60indicator-position%60%20%E5%B1%9E%E6%80%A7%E5%AE%9A%E4%B9%89%E4%BA%86%E6%8C%87%E7%A4%BA%E5%99%A8%E7%9A%84%E4%BD%8D%E7%BD%AE%E3%80%82%E9%BB%98%E8%AE%A4%E6%83%85%E5%86%B5%E4%B8%8B%EF%BC%8C%E5%AE%83%E4%BC%9A%E6%98%BE%E7%A4%BA%E5%9C%A8%E8%B5%B0%E9%A9%AC%E7%81%AF%E5%86%85%E9%83%A8%EF%BC%8C%E8%AE%BE%E7%BD%AE%E4%B8%BA%20%60outside%60%20%E5%88%99%E4%BC%9A%E6%98%BE%E7%A4%BA%E5%9C%A8%E5%A4%96%E9%83%A8%EF%BC%9B%E8%AE%BE%E7%BD%AE%E4%B8%BA%20%60none%60%20%E5%88%99%E4%B8%8D%E4%BC%9A%E6%98%BE%E7%A4%BA%E6%8C%87%E7%A4%BA%E5%99%A8%E3%80%82%0A%20%20%20%20%20%20%20%20%3C%2Fot-notice%3E%0A%20%20%20%20%20%20%20%20%3Cot-row-group%20%3Afixable%3D%22false%22%20%3Aflex%3D%22false%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-carousel%20indicator-position%3D%22outside%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-carousel-item%20v-for%3D%22item%20in%20'abcd'.split('')%22%20%3Akey%3D%22item%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Ch3%3E%7B%7B%20item%20%7D%7D%3C%2Fh3%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-carousel-item%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-carousel%3E%0A%20%20%20%20%20%20%20%20%3C%2Fot-row-group%3E%0A%20%20%20%20%3C%2Fot-section%3E%0A%3C%2Ftemplate%3E%0A%0A%3Cscript%3E%0Aexport%20default%20%7B%0A%20%20%20%20data()%20%7B%0A%20%20%20%20%20%20%20%20return%20%7B%0A%20%20%20%20%20%20%20%20%7D%3B%0A%20%20%20%20%7D%2C%0A%7D%3B%0A%3C%2Fscript%3E%0A%0A%3Cstyle%20lang%3D%22scss%22%20scoped%3E%0A.ot-row-group%20%7B%0A%20%20%20%20text-align%3A%20center%3B%0A%7D%0A.ot-carousel-item%20h3%20%7B%0A%20%20%20%20color%3A%20%23475669%3B%0A%20%20%20%20opacity%3A%200.75%3B%0A%20%20%20%20line-height%3A%2023em%3B%0A%20%20%20%20vertical-align%3A%20middle%3B%0A%20%20%20%20margin%3A%200%3B%0A%7D%0A%0A.ot-carousel-item%3Anth-child(2n)%20%7B%0A%20%20%20%20background-color%3A%20%2399a9bf%3B%0A%7D%0A%0A.ot-carousel-item%3Anth-child(2n%2B1)%20%7B%0A%20%20%20%20background-color%3A%20%23d3dce6%3B%0A%7D%0A%3C%2Fstyle%3E`),
        };
    },
};
</script>

<style lang="scss" scoped>
.ot-row-group {
    text-align: center;
}
.ot-carousel-item h3 {
    color: #475669;
    opacity: 0.75;
    line-height: 23em;
    vertical-align: middle;
    margin: 0;
}

.ot-carousel-item:nth-child(2n) {
    background-color: #99a9bf;
}

.ot-carousel-item:nth-child(2n+1) {
    background-color: #d3dce6;
}
</style>
